/** Six cards each; the talon refills them until it is closed or gone. Twelve
 *  tricks is the most a hand can have (all 24 cards played). */
export const SIXTY_SIX_MAX_TRICKS = 12;
export const SIXTY_SIX_HAND = 6;
/** What a player needs to go out (rules §7). */
export const SIXTY_SIX_OUT = 66;
/** Under this, the loser is "schneider" and pays two (rules §8). */
export const SIXTY_SIX_SCHNEIDER = 33;
export const SIXTY_SIX_LAST_TRICK = 10;
export const SIXTY_SIX_MARRIAGE = 20;
export const SIXTY_SIX_TRUMP_MARRIAGE = 40;
export const DEFAULT_SIXTY_SIX_CONFIG = { target: 11 };
/** Partial, forgiving merge, the same contract as the other games. */
export function validateSixtySixConfig(raw) {
    if (raw === undefined || raw === null)
        return { ok: true, config: DEFAULT_SIXTY_SIX_CONFIG };
    if (typeof raw !== 'object')
        return { ok: false, error: 'config must be an object' };
    const r = raw;
    const out = { ...DEFAULT_SIXTY_SIX_CONFIG };
    if (r.target !== undefined) {
        const v = r.target;
        if (typeof v !== 'number' || !Number.isInteger(v) || v < 1 || v > 100) {
            return { ok: false, error: 'target must be an integer in [1, 100]' };
        }
        out.target = v;
    }
    return { ok: true, config: out };
}
//# sourceMappingURL=config.js.map